import screen from "../constants/screen";
import ScreenModes from "../constants/screenModes";

export default () => {
  let width = null;
  let height = null;
  let screenMode = null;

  // Note: the old v2 code used REM rather than pixels
  // Note: the old V2 code had a medium and wide screen mode that functioned a little differently (at 800px)

  // #!if iOS === true
  // Changed from window.innerWidth/innerHeight to document.documentElement.clientWidth/clientHeight
  // because there was a bug in iOS where the innerWidth/innerHeight do not update correctly when rotating
  // the device (at least not by the time the resize event is fired)
// width = document.documentElement.clientWidth;
// height = document.documentElement.clientHeight;
  // #!else
  width = window.innerWidth;
  height = window.innerHeight;
  // #!endif

  // #!if mobile === true
// const isLandscape = width > height;
// screenMode = isLandscape ? ScreenModes.MobileLandscape : ScreenModes.MobilePortrait;
  // #!elseif tablet === true
// screenMode = ScreenModes.Tablet;
  // #!elseif harvard === true
  screenMode = width < screen.TABLET_MIN_WIDTH ? ScreenModes.MobilePortrait : ScreenModes.Desktop;
  // #!else
// screenMode = ScreenModes.Desktop;
  // #!endif

  return { width, height, screenMode };
};
